(function () {

  angular.module('PrintRulesProvider', [])

    .factory('PrintRulesService', function ($http, TenantListService) {
      const printRulesBaseURL = TenantListService.currentTenant.info._embedded.productsAndFeatures._links['px:printrule'].href;
      return {

        getConfig: function () {
          return $http.get(printRulesBaseURL)
            .then(function (printRulesConfigRes) {
              return printRulesConfigRes.data;
            })
            .catch(function () {
            });
        },

        createDefaultConfig: function () {
          return $http.post(`${printRulesBaseURL}/default`);
        },

        updatePrintRule: function (patchData, isRule = true) {
          const paths = [];
          const ruleUrl = isRule ? 'rules/' : '';
          Object.keys(patchData).forEach(function (key) {
            paths.push({
              op: 'replace',
              path: `/${ruleUrl}${key}`,
              value: patchData[key]
            });
          });
          return $http.patch(`${printRulesBaseURL}`, paths)
            .then(function (response) {
              return response.data;
            })
            .catch(function () {
            });
        },

        updatePrintRuleGroups: function (payload, isBlackWhiteGroup = true) {
          const groupType = isBlackWhiteGroup ? 'BLACK_AND_WHITE' : 'DUPLEX_MODE';
          const data = [];
          if (payload?.add) {
            const addPayload = {
              type: 'ADD',
              groups: payload.add
            };
            data.push(addPayload);
          }
          if (payload?.delete) {
            const deletePayload = {
              type: 'DELETE',
              groups: payload.delete
            };
            data.push(deletePayload);
          }
          return $http.post(`${printRulesBaseURL}/${groupType}/updateRequests`, data)
            .then(function (response) {
              return response.data;
            })
            .catch(function () {
            });
        }

      };
    });

})();
